let audio,
    gameFrame,
    isFullscreen = false,
    gameData = {},
    memoryTimer = null,
    originalItems = [],
    shuffledItems = [],
    movedIndices = [],
    foundCount = 0;

class MotionMemoGame {
    constructor() {
        this.memoryPhase = document.querySelector('[data-phase="memory"]');
        this.findPhase = document.querySelector('[data-phase="find"]');
        this.resultPhase = document.querySelector('[data-phase="result"]');
        this.timerElement = document.querySelector('[data-timer]');
        this.shuffledContainer = document.querySelector('[data-items-shuffled]');
        this.foundCountEl = document.querySelector('[data-found-count]');

        // Pobierz dane z window
        if (window.motionMemoData) {
            gameData = window.motionMemoData;
            originalItems = [...gameData.items];
        }

        this.init();
    }

    init() {
        this.startMemoryPhase();
    }

    startMemoryPhase() {
        let timeLeft = gameData.memoryTime;

        // Odtwórz dźwięk startu
        if (audio && audio.start) {
            audio.start.play();
            stopAudioAfterDelay(audio.start, 2000);
        }

        memoryTimer = setInterval(() => {
            timeLeft--;

            if (this.timerElement) {
                this.timerElement.textContent = timeLeft;

                // Animacja ostatnich 3 sekund
                if (timeLeft <= 3) {
                    this.timerElement.classList.add('timer-warning');
                    if (audio && audio.drag) {
                        audio.drag.play();
                    }
                }
            }

            if (timeLeft <= 0) {
                clearInterval(memoryTimer);
                this.switchToFindPhase();
            }
        }, 1000);
    }

    switchToFindPhase() {
        // Ukryj fazę zapamiętywania
        if (this.memoryPhase) {
            this.memoryPhase.classList.add('hidden');
        }

        // Przygotuj przesunięte elementy
        this.prepareShuffledItems();

        // Pokaż fazę szukania
        if (this.findPhase) {
            this.findPhase.classList.remove('hidden');
        }

        // Dźwięk przejścia
        if (audio && audio.drag) {
            audio.drag.play();
            stopAudioAfterDelay(audio.drag, 2000);
        }
    }

    prepareShuffledItems() {
        // Skopiuj oryginalne elementy
        shuffledItems = [...originalItems];

        // Wybierz losowe indeksy do zamiany
        movedIndices = [];
        const movesToMake = parseInt(gameData.movesCount);
        const availableIndices = shuffledItems.map((item, idx) => idx);

        // Wybierz losowe indeksy
        while (movedIndices.length < movesToMake && availableIndices.length >= 2) {
            const randomIdx = Math.floor(Math.random() * availableIndices.length);
            const selectedIndex = availableIndices[randomIdx];
            movedIndices.push(selectedIndex);
            availableIndices.splice(randomIdx, 1);
        }

        // Zamień pozycje wybranych elementów
        if (movedIndices.length === 1) {
            // Jeden element - zamień z sąsiadem
            const idx = movedIndices[0];
            const swapWith = idx === shuffledItems.length - 1 ? idx - 1 : idx + 1;
            [shuffledItems[idx], shuffledItems[swapWith]] = [shuffledItems[swapWith], shuffledItems[idx]];
            movedIndices.push(swapWith);
        } else if (movedIndices.length === 2) {
            // Dwa elementy - zamień między sobą
            const [idx1, idx2] = movedIndices;
            [shuffledItems[idx1], shuffledItems[idx2]] = [shuffledItems[idx2], shuffledItems[idx1]];
        }

        // Renderuj przesunięte elementy
        this.renderShuffledItems();
    }

    renderShuffledItems() {
        if (!this.shuffledContainer) return;

        this.shuffledContainer.innerHTML = '';

        shuffledItems.forEach((item, currentPosition) => {
            const itemEl = document.createElement('div');
            itemEl.className = 'motion-item find-phase';
            itemEl.dataset.itemId = item.id;
            itemEl.dataset.originalPosition = item.original_position;
            itemEl.dataset.currentPosition = currentPosition;

            // Sprawdź czy element się przesunął
            const hasMoved = item.original_position !== currentPosition;
            itemEl.dataset.hasMoved = hasMoved ? 'true' : 'false';

            itemEl.innerHTML = '<img src="' + item.image + '" alt="' + (item.name || '') + '" class="motion-item-image">';
            if (item.name) {
                itemEl.innerHTML += '<span class="motion-item-name">' + item.name + '</span>';
            }

            // Event listener
            itemEl.addEventListener('click', () => this.handleItemClick(itemEl, item, currentPosition));

            this.shuffledContainer.appendChild(itemEl);
        });

        // Animacja pojawienia się elementów
        setTimeout(() => {
            const allItems = this.shuffledContainer.querySelectorAll('.motion-item');
            allItems.forEach((item, i) => {
                setTimeout(() => {
                    item.classList.add('revealed');
                }, i * 100);
            });
        }, 300);
    }

    handleItemClick(itemEl, item, currentPosition) {
        // Sprawdź czy element już został kliknięty
        if (itemEl.classList.contains('clicked')) {
            return;
        }

        itemEl.classList.add('clicked');

        const hasMoved = item.original_position !== currentPosition;

        if (hasMoved) {
            // Poprawnie znaleziony przesunięty element
            this.handleCorrectClick(itemEl);
        } else {
            // Błędnie kliknięty element (nie został przesunięty)
            this.handleWrongClick(itemEl);
        }
    }

    handleCorrectClick(itemEl) {
        foundCount++;

        // Animacja sukcesu
        itemEl.classList.add('correct');

        // Aktualizuj licznik
        if (this.foundCountEl) {
            this.foundCountEl.textContent = foundCount;
        }

        // Dźwięk sukcesu
        if (audio && audio.valid) {
            audio.valid.play();
            stopAudioAfterDelay(audio.valid, 1000);
        }

        // Flash zielony
        gameFrame.style.borderColor = 'green';
        setTimeout(() => {
            gameFrame.style.borderColor = 'black';
        }, 500);

        // Sprawdź czy znaleziono wszystkie
        if (foundCount >= movedIndices.length) {
            setTimeout(() => {
                this.showResult(true);
            }, 1000);
        }
    }

    handleWrongClick(itemEl) {
        // Animacja błędu
        itemEl.classList.add('incorrect');

        // Dźwięk błędu
        if (audio && audio.wrong) {
            audio.wrong.play();
            stopAudioAfterDelay(audio.wrong, 1000);
        }

        // Flash czerwony
        gameFrame.style.borderColor = 'red';
        setTimeout(() => {
            gameFrame.style.borderColor = 'black';
        }, 500);

        // Usuń klasę po chwili, żeby można było kliknąć ponownie
        setTimeout(() => {
            itemEl.classList.remove('clicked', 'incorrect');
        }, 1000);
    }

    showResult(success) {
        // Ukryj fazę szukania
        if (this.findPhase) {
            this.findPhase.classList.add('hidden');
        }

        // Pokaż fazę wyniku
        if (this.resultPhase) {
            this.resultPhase.classList.remove('hidden');
        }

        // Ustaw treść wyniku
        const resultIcon = this.resultPhase.querySelector('[data-result-icon]');
        const resultTitle = this.resultPhase.querySelector('[data-result-title]');
        const resultMessage = this.resultPhase.querySelector('[data-result-message]');
        const originalItemsEl = this.resultPhase.querySelector('[data-original-items]');
        const movedItemsEl = this.resultPhase.querySelector('[data-moved-items]');

        if (success) {
            if (resultIcon) {
                resultIcon.innerHTML = '<i class="fa fa-check-circle"></i>';
                resultIcon.className = 'result-icon success';
            }
            if (resultTitle) {
                resultTitle.textContent = 'Brawo! Znalazłeś wszystkie przesunięte elementy!';
                resultTitle.className = 'result-title success';
            }
            if (resultMessage) {
                resultMessage.textContent = 'Świetnie zapamiętałeś oryginalne pozycje i zauważyłeś wszystkie zmiany!';
            }

            // Dźwięk sukcesu
            if (audio && audio.success) {
                audio.success.play();
                stopAudioAfterDelay(audio.success, 3000);
            }
        }

        // Pokaż porównanie
        if (originalItemsEl) {
            originalItemsEl.innerHTML = '';
            originalItems.forEach(item => {
                const div = document.createElement('div');
                div.className = 'result-item';
                div.innerHTML = '<img src="' + item.image + '" alt="' + (item.name || '') + '">';
                originalItemsEl.appendChild(div);
            });
        }

        if (movedItemsEl) {
            movedItemsEl.innerHTML = '';
            shuffledItems.forEach((item, idx) => {
                const div = document.createElement('div');
                div.className = 'result-item';
                const wasMoved = item.original_position !== idx;
                if (wasMoved) {
                    div.classList.add('moved');
                }
                div.innerHTML = '<img src="' + item.image + '" alt="' + (item.name || '') + '">';
                movedItemsEl.appendChild(div);
            });
        }
    }

    restart() {
        // Reset zmiennych
        foundCount = 0;
        movedIndices = [];
        shuffledItems = [];

        // Zatrzymaj timer
        if (memoryTimer) {
            clearInterval(memoryTimer);
        }

        // Reset timera
        if (this.timerElement) {
            this.timerElement.textContent = gameData.memoryTime;
            this.timerElement.classList.remove('timer-warning');
        }

        // Reset licznika
        if (this.foundCountEl) {
            this.foundCountEl.textContent = '0';
        }

        // Reset faz
        if (this.memoryPhase) {
            this.memoryPhase.classList.remove('hidden');
        }
        if (this.findPhase) {
            this.findPhase.classList.add('hidden');
        }
        if (this.resultPhase) {
            this.resultPhase.classList.add('hidden');
        }

        // Wyczyść container
        if (this.shuffledContainer) {
            this.shuffledContainer.innerHTML = '';
        }

        // Reset ramki
        gameFrame.style.borderColor = 'black';

        // Rozpocznij od nowa
        this.startMemoryPhase();
    }
}

// Helper function
function stopAudioAfterDelay(audioElement, delay) {
    setTimeout(() => {
        if (audioElement) {
            audioElement.pause();
            audioElement.currentTime = 0;
        }
    }, delay);
}

// Initialize game function
function initGame() {
    gameFrame = document.querySelector('.game__frame--motion-memo');

    if (!gameFrame) {
        return;
    }

    // Initialize audio
    audio = {
        start: document.getElementById('sound-start'),
        valid: document.getElementById('sound-valid'),
        wrong: document.getElementById('sound-wrong'),
        success: document.getElementById('sound-success'),
        drag: document.getElementById('sound-drag')
    };

    // Initialize game
    const game = new MotionMemoGame();

    // Fullscreen toggle
    const fullscreenButton = document.querySelector('[data-toggle-fullscreen]');
    if (fullscreenButton) {
        fullscreenButton.addEventListener('click', () => {
            if (!isFullscreen) {
                if (gameFrame.requestFullscreen) {
                    gameFrame.requestFullscreen();
                } else if (gameFrame.webkitRequestFullscreen) {
                    gameFrame.webkitRequestFullscreen();
                } else if (gameFrame.msRequestFullscreen) {
                    gameFrame.msRequestFullscreen();
                }
                fullscreenButton.querySelector('i').classList.remove('fa-expand');
                fullscreenButton.querySelector('i').classList.add('fa-compress');
                isFullscreen = true;
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
                fullscreenButton.querySelector('i').classList.remove('fa-compress');
                fullscreenButton.querySelector('i').classList.add('fa-expand');
                isFullscreen = false;
            }
        });
    }

    // Restart buttons
    const restartButtons = document.querySelectorAll('[data-game-restart]');
    restartButtons.forEach(button => {
        button.addEventListener('click', () => {
            game.restart();
        });
    });

    // Back button
    const backButton = document.querySelector('[data-backward]');
    if (backButton) {
        backButton.addEventListener('click', () => {
            if (memoryTimer) {
                clearInterval(memoryTimer);
            }
            window.history.back();
        });
    }
}

export default { initGame };




// WEBPACK FOOTER //
// ./src/scripts/game-motion-memo.js